import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import baseuri from '../../baseuri';
import { randomgen } from '../../utils/general-utils';
import { addToLoadingQueue, removeFromLoadingQueue } from './general';

export const retrieveVirtualFiatAccounts = createAsyncThunk(
	'virtualFiatAccount/retrieveVirtualFiatAccounts',
	async (params: any, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		const res = await baseuri.get('/admin/virtual-fiat-accounts', { params });
		dispatch(removeFromLoadingQueue(loadingId));
		return res.data.data;
	}
);

export const getSingleVirtualAccount = createAsyncThunk(
	'virtualFiatAccount/getSingleVirtualAccount',
	async (id: string, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		const res = await baseuri.get(`/admin/virtual-fiat-accounts/${id}`);
		dispatch(removeFromLoadingQueue(loadingId));
		return res.data.data;
	}
);

const virtualFiatAccountRX = createSlice({
	name: 'virtualFiatAccount',
	initialState: {
		data: {
			itemsList: [],
			paginator: {
				hasNextPage: false,
				hasPrevPage: false,
				pageCount: 0,
				itemCount: 0,
				next: 0,
				pagingCounter: 0,
				perPage: 0,
				prev: 0,
				currentPage: 0,
			},
		},
		singleData: null,
	},
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(retrieveVirtualFiatAccounts.fulfilled, (store, action) => {
				const state = store;
				state.data = action.payload;
			})
			.addCase(getSingleVirtualAccount.fulfilled, (store, action) => {
				const state = store;
				state.singleData = action.payload;
			}),
});

export default virtualFiatAccountRX.reducer;
